import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const ResultTile: StyleRule = () => ({
    height: pxToRem(66),
    width: '100%',
    padding: pxArrayToRem([9, 8]),
    cursor: 'pointer',
    [`&:hover`]: {
        background: `rgba(0, 0, 0, 0.06)`,
    },
});

export const ResultTileThumb: StyleRule<{
    logoBackground?: string;
    isProfessional?: boolean;
}> = ({ theme, logoBackground, isProfessional }) => {
    // Both professionals and products use 48x48px containers
    // Professionals get circular containers with border and padding
    // Products stay as square containers
    const baseStyles = {
        background:
            logoBackground ?? theme.siteVariables.colors.primitive.white,
        position: 'relative' as const,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: pxToRem(48),
        width: pxToRem(48),
        minWidth: pxToRem(48),
    };

    if (isProfessional) {
        return {
            ...baseStyles,
            borderRadius: '50%',
            border: `1px solid ${theme.siteVariables.colors.white[300]}`,
            padding: pxToRem(4),
            overflow: 'hidden',
        };
    }

    return baseStyles;
};

export const ResultTileContent: StyleRule = () => ({
    justifyContent: 'center',
    maxWidth: pxToRem(282),
});

export const ResultTileTitle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal['300'],
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
export const ResultTileProfessional: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.grey['400'],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: pxToRem(2),
});
